module.exports = __webpack_public_path__ + "img/benefits-01.95debd79.png";